<template>
    <div>
        <b-row v-if="Object.keys(tableData).length > 0">
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Age:</span>
                    {{ tableData[0].customer_age }}
                </p>
            </b-col>
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Property Value:</span>
                    RM {{ tableData[0].property_value }}
                </p>
            </b-col>
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Commitment Amount:</span>
                    {{ tableData[0].commitment_amount }}
                </p>
            </b-col>
            <b-col cols="12" md="6">
                <p>
                    <span class="font-weight-600">Bank Outstanding:</span>
                    RM {{ tableData[0].bank_outstanding }}
                </p>
            </b-col>
        </b-row>
        
        <b-table-simple responsive bordered class="mt-4 table-fixed-left">
            <tbody>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Bank</b-th>
                    <b-th class="table-danger text-dark" v-for="(bank, index) in tableData" :key="index">
                        {{ bank.bank_name }}
                    </b-th>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column" fixed>Net Salary Income</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">
                        RM {{ bank.net_income | moneyFormatter }}
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Property Value</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.property_value | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Target MOF (Loan Margin)</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">{{ bank.loan_margin }}%</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Target Loan Amount</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.loan_amount | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Bank Outstanding</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.bank_outstanding | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Cashout</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.cashout_amount | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Interest Rate</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">{{ bank.interest_rate_percent }}%</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Loan Term in Years</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">{{ bank.loan_years }} Years</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Target Instalment (Monthly Instalment)</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.target_instalment | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Bank Outstanding Instalment</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.bank_outstanding_instalment | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Cashout Instalment</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.cashout_instalment | moneyFormatter }}</b-td>
                </b-tr>
                <b-tr>
                    <b-th class="table-dark text-light fixed-left-column">Total Instalment (Bank Outstanding + Cashout)</b-th>
                    <b-td v-for="(bank, index) in tableData" :key="index" class="text-right">RM {{ bank.total_instalment | moneyFormatter }}</b-td>
                </b-tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script>
export default {
    props: {
        tableData: Array | Object,
    },

    mounted() {
        const tableBody = document.querySelector('.table-fixed-left tbody');
        tableBody.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {

            const firstColumnCells = document.querySelectorAll('.table-fixed-left .fixed-left-column');

            firstColumnCells.forEach((cell) => {
            cell.style.left = `${cell.parentElement.scrollLeft}px`;
            });
        },
    },
    beforeDestroy() {
        const tableBody = document.querySelector('.table-fixed-left tbody');
        tableBody.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style scoped>
.table-fixed-left .fixed-left-column {
    position: sticky;
    left: 0;
    z-index: 2;
}

.table-fixed-left .b-table-sticky-header th:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
}
</style>